import ClickOutside from 'vue-click-outside';

export default {
    name: 'QPopover',
    directives: {
        ClickOutside,
    },
    props: {
        // Aligns the popover accordingly with the trigger.
        // i.e. bottom, center, left, middle, right, top.
        align: {
            type: String,
            default: 'left'
        },
        // Toggles the content from the parent component.
        // i.e. false, true.
        open: {
            type: Boolean,
            default: false
        },
        // Positions the popover to the specified side of the trigger.
        // i.e. bottom, left, right, top.
        position: {
            type: String,
            default: 'bottom'
        },
        // Specifies the size of the popover.
        // i.e. sm, md, lg.
        size: {
            type: String,
            default: 'md'
        },
        // Specifies whether to have a caret pointer or not.
        hasCaret: {
            type: Boolean,
            default: true
        },
        // Old
        title: {
            type: String,
            default: ''
        },
        content: {
            type: [String, Array, Object],
            default: ''
        },
        useHover: {
            type: Boolean,
            default: true
        },
        isBlock: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            popoverRef: null,
            offsetStyle: '',
        };
    },
    methods: {
        onClickOutside() {
            this.$emit('close');
        },
        setOffsetStyle() {
            const triggerElement = this.$el.querySelector('.trigger-text');

            if (triggerElement) {
                const triggerWidth = triggerElement.clientWidth;
                const triggerHeight = triggerElement.clientHeight;

                if (this.align === 'left') {
                    this.offsetStyle =
                        'margin-left: ' + ((triggerWidth / 2) - 10) + 'px;';
                }
                if (this.align === 'right') {
                    this.offsetStyle =
                        'margin-right: ' + ((triggerWidth / 2) - 10) + 'px;';
                }
                if (this.align === 'top') {
                    this.offsetStyle =
                        'margin-top: ' + ((triggerHeight / 2) - 10) + 'px;';
                }
                if (this.align === 'bottom') {
                    this.offsetStyle =
                        'margin-bottom: ' + ((triggerHeight / 2) - 10) + 'px;';
                }
            }
        },
    },
    watch: {
        align() {
            this.setOffsetStyle();
        }
    },
    mounted() {
        this.setOffsetStyle();
    },
};
